export default [
  {
    path: '/reference',
    name: 'reference',
    component: () => import('@/views/modules/Reference/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [{
        text: 'sidebar.administration',
        active: true,
      },
      {
        text: 'others.references',
        active: true,
      },
      ],
    },
  },
]
